import { styled } from '@mui/material/styles'

export const SpanTitleCustom = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}))

export const SpanSubtitleCustom = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
}))
